// import './SelectTipoRelatorio.css';

import { useEffect, useState } from 'react';

import { servGetTiposRelatorioPorCpf } from '../../servicos/servicosEmRotasPrivadas/tipo_relatorio';

function SelectTipoRelatorioControlled({ id, value, onChange }) {

    const [tipoRelatorioList, setTipoRelatorioList] = useState([])

    useEffect(() => {
        getTiposRelatorioPorCpf()
    }, []);

    const getTiposRelatorioPorCpf = async () => {
        try {
            const tipoRelatorioDaApi = await servGetTiposRelatorioPorCpf()
            setTipoRelatorioList(tipoRelatorioDaApi)
        } catch (erro) {
            console.error(erro);
        }
    }

    const handleChange = (codigoTipoRelatorio) => {
        const tipoRelatorioSelecionado = tipoRelatorioList.find(
            item => item.codigo === Number(codigoTipoRelatorio)
        );       
        if (tipoRelatorioSelecionado) onChange(tipoRelatorioSelecionado)
    };

    return (
        <>
            {tipoRelatorioList ? (
                <div>
                    <select
                        className="form-select form-select-sm w-100"
                        id={id}
                        value={value || ''}
                        name="status"
                        // onChange={(e) => onChange(Number(e.target.value) || null)}
                        onChange={(e) => handleChange(e.target.value) || null}
                    >
                        <option value="">Selecione uma opção</option>
                        {tipoRelatorioList.map((tipoRelatorio) => (
                            <option key={tipoRelatorio.codigo} value={tipoRelatorio.codigo}>
                                {tipoRelatorio.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <>
                    <p>Carregando informações dos tipos de relatórios...</p>
                </>
            )}
        </>
    )
}

export default SelectTipoRelatorioControlled